import { useState, useEffect } from 'react';
import api from '../../services/api';

const usePermissions = () => {
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPermissions = async () => {
    // Verificar se o usuário está logado
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('Usuário não está logado, usando permissões padrão');
      setPermissions({
        isAdmin: false,
        profile: 'user',
        super: false,
        userId: '',
      });
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await api.get('/metrics/permissions');
      setPermissions(response.data);
    } catch (err) {
      setError('Erro ao carregar permissões');
      console.error('Erro ao buscar permissões:', err);

      // Fallback: usar dados do contexto de autenticação
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      setPermissions({
        isAdmin: user.profile === 'admin',
        profile: user.profile || 'user',
        super: user.super || false,
        userId: user.id?.toString() || '',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadPermissions = async () => {
      if (!isMounted) return;

      // Verificar se o usuário está logado
      const token = localStorage.getItem('token');
      if (!token) {
        console.warn('Usuário não está logado, usando permissões padrão');
        if (isMounted) {
          setPermissions({
            isAdmin: false,
            profile: 'user',
            super: false,
            userId: '',
          });
          setLoading(false);
        }
        return;
      }

      try {
        if (isMounted) {
          setLoading(true);
          setError(null);
        }

        const response = await api.get('/metrics/permissions');
        if (isMounted) {
          setPermissions(response.data);
        }
      } catch (err) {
        if (isMounted) {
          setError('Erro ao carregar permissões');
          console.error('Erro ao buscar permissões:', err);

          // Fallback: usar dados do contexto de autenticação
          const user = JSON.parse(localStorage.getItem('user') || '{}');
          setPermissions({
            isAdmin: user.profile === 'admin',
            profile: user.profile || 'user',
            super: user.super || false,
            userId: user.id?.toString() || '',
          });
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPermissions();

    return () => {
      isMounted = false;
    };
  }, []);

  return { permissions, loading, error, refetch: fetchPermissions };
};

export default usePermissions;
